import { Chip, List, styled } from '@mui/material';

export const CompanyLogoBase = styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
        maxHeight: "30px",
        maxWidth: "100px"
    },
    "&.mini": {
        "& img": {
            marginTop: "2px",
            maxHeight: "16px",
            maxWidth: "100px",
        }
    },
    "&.large": {
        "& img": {
            maxHeight: "50px",
            maxWidth: "175px",
        }
    },
    "&.left": {
        justifyContent: "flex-start",
        padding: "0px",
    },
    "&.right": {
        justifyContent: "flex-end",
        padding: "",
    }
}));

export const CompanyNameBase = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.2rem",
    fontWeight: 700,
    "&.left": {
        justifyContent: "flex-start",
    },
    "&.right": {
        justifyContent: "flex-end",
    },
    "&.mini": {
        fontSize: "0.8rem",
        padding: "0px",
    },
    "&.large": {
        fontSize: "1.5rem",
    }
}));

export const ProfileImageBase = styled('div')(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '50%',
  border: `1px solid ${theme.palette.grey[300]}`,
  boxShadow: `inset 0 0 5px ${theme.palette.grey[300]}`,
  textAlign: 'center',
  '&.small': {
    width: '50px',
    height: '50px'
  },
  '&.medium': {
    width: '80px',
    height: '80px'
  },
  '&.large': {
    width: '120px',
    height: '120px'
  }
}));

export const AdvisorFeatureListBase = styled(List)(({ theme }) => ({
    padding: "0px",
    "& .MuiListItem-root": {
        padding: "0px",
        marginTop: "20px",
        fontSize: "0.85rem",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "10px",
        "&:last-child": {
            marginBottom: "20px",
        }
    }
}));

export const DisplayBoxBase = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '15px 15px',
    backgroundColor: '#ffffff',
    borderRadius: '5px',
    border: `1px solid transparent`,
    boxShadow: `0 0 5px #c9c9c9`,
    transition: 'box-shadow 0.3s ease',
    '&.white': {
        backgroundColor: '#ffffff',
    },
    '&.grey, &.gray': {
        backgroundColor: '#f8f9fa',
    },
    '&.active': {
        boxShadow: `0 0 5px #1a5dbd`,
    },
    "&.highlighted": {
        boxShadow: "0 0 5px #1a5dbd",
        border: "1px solid #1a5dbd",
        backgroundColor: "#f0f6ff"
    },
    "&.transparent": {
        backgroundColor: "transparent",
        boxShadow: "none",
        border: "1px solid transparent",
    },
    '&.column': {   
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        '&.center': {
            alignItems: 'center',
        }
    },
    '&.row': {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));

export const TagChip = styled(Chip)<{ variant?: 'outlined' | 'filled' }>(({ theme, variant }) => ({
    color: "#222",
    padding: "0.2rem 0.5rem",
    borderRadius: "0.3rem",
    fontSize: "0.8rem",
    borderColor: "#c9c9c9",
    borderWidth: "1px",
    height: "auto",
    "&:hover": {
        backgroundColor: "#f0f6ff",
        borderColor: theme.palette.primary.main,
        borderWidth: "1px",
        borderStyle: "solid"
    },
    ...(variant === 'filled' && {
        color: theme.palette.primary.main,
        backgroundColor: "#f0f6ff",
        borderColor: theme.palette.primary.main,
        borderWidth: "1px",
        borderStyle: "solid"
    })
}));